import { Button, Card, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { gradientBrand, passtrackColors } from "../theme";
import { useAuth } from "../routing/AuthContext";
import {
  EntryLogo,
  EntryShell,
  entryMenuCardSx,
} from "../routing/entryShell";
import { ROUTES } from "../routing/paths";

const primaryButtonSx = {
  py: 1.25,
  fontWeight: 700,
  backgroundImage: gradientBrand,
  "&:hover": {
    backgroundImage: gradientBrand,
    filter: "brightness(0.95)",
  },
} as const;

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleBackToLogin = () => {
    logout();
    navigate(ROUTES.login, { replace: true });
  };

  return (
    <EntryShell>
      <Card variant="outlined" sx={{ ...entryMenuCardSx, textAlign: "center" }}>
        <EntryLogo />
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 24,
            color: passtrackColors.ink,
            mb: 1,
          }}
        >
          Acceso no autorizado
        </Typography>
        <Typography
          sx={{ fontSize: 14, color: passtrackColors.textMuted, mb: 3 }}
        >
          Tu cuenta no tiene permisos para configurar propiedades. Solo usuarios
          con rol de administración o internal_operation pueden continuar.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          onClick={handleBackToLogin}
          sx={primaryButtonSx}
        >
          Volver al inicio de sesión
        </Button>
      </Card>
    </EntryShell>
  );
}
